import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part6 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        return (
            <div className="docs-content">
                <div className="container">

                    {/* ========================= */}
                    {/* 1. RELATIONSHIP */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            12. Relationship
                        </h1>

                        <div className="alert alert-info">
                            Legal or economic relationship between sender and receiver.
                        </div>

                        <h5 className="mt-4">Why It Matters</h5>
                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li>AML risk scoring</li>
                                <li>Corridor legality</li>
                                <li>Regulatory reporting</li>
                            </ul>
                        </div>

                        <h5 className="mt-4">Examples</h5>
                        <div className="alert alert-secondary mt-3">
                            <strong>FATHER</strong> &nbsp; | &nbsp;
                            <strong>EMPLOYER</strong> &nbsp; | &nbsp;
                            <strong>SUPPLIER</strong> &nbsp; | &nbsp;
                            <strong>SELF</strong>
                        </div>
                    </article>


                    {/* ========================= */}
                    {/* 2. PURPOSE OF PAYMENT */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            13. Purpose of Payment
                        </h1>

                        <div className="alert alert-info">
                            Declared reason for the transaction.
                        </div>

                        <h5 className="mt-4">Why It Matters</h5>
                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li>Regulatory controls (e.g., GCC)</li>
                                <li>Capital controls</li>
                                <li>Sanctions filtering</li>
                            </ul>
                        </div>
                    </article>


                    {/* ========================= */}
                    {/* 3. SOURCE OF FUNDS */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            14. Source of Funds
                        </h1>

                        <div className="alert alert-info">
                            Origin of money being sent.
                        </div>

                        <h5 className="mt-4">Examples</h5>
                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li><strong>SALARY</strong></li>
                                <li><strong>BUSINESS_INCOME</strong></li>
                                <li><strong>SAVINGS</strong></li>
                                <li><strong>CRYPTO_PROCEEDS</strong></li>
                            </ul>
                        </div>

                        <div className="alert alert-warning mt-4">
                            Always collect, even if PSP does not ask.
                        </div>
                    </article>


                    {/* ========================= */}
                    {/* 4. KYC LEVEL */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            15. KYC Level
                        </h1>

                        <div className="alert alert-info">
                            Degree of identity verification completed.
                        </div>

                        <h5 className="mt-4">Typical Levels</h5>
                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li><strong>NONE</strong></li>
                                <li><strong>BASIC</strong></li>
                                <li><strong>FULL</strong></li>
                                <li><strong>ENHANCED</strong></li>
                            </ul>
                        </div>
                    </article>


                    {/* ========================= */}
                    {/* 5. SANCTIONS & PEP SCREENING */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            16. Sanctions and PEP Screening
                        </h1>

                        <div className="alert alert-info">
                            Checks against restricted persons or politically exposed persons.
                        </div>

                        <h5 className="mt-4">Required Fields</h5>
                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li><strong>screened_at</strong> (timestamp)</li>
                                <li><strong>provider used</strong></li>
                                <li><strong>result</strong></li>
                            </ul>
                        </div>
                    </article>

                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-five-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part V
                                            </Link>
                                        </li>
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-seven-doc">
                                                Part VII &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>

                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}